/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import community_icon from "../../../../images/Oscar.svg";
import PaginationComponent from "../../../Pagination/pagination";
import Chip from "@mui/material/Chip";
import UploadBannerModal from "./UploadBannerModal";
import {
  fetchAllCities,
  vendorFetchSubscriptionApi,
  vendorCancelSubscriptionApi,
  fetchBannerImage,
} from "../../../../Services/Vendor/VendorApi/VendorApi";
import { useSelector, useDispatch } from "react-redux";
import Tooltip from "@mui/material/Tooltip";
import PurchaseSubscriptionModal from "../PurchaseSubscriptionModal";
import { Box } from "@mui/material";
import { toast } from "react-toastify";
import ViewImageModal from "./ViewImageModal";
import Modal from "react-bootstrap/Modal";
import AlertDialog from "./UploadReminderDialog";
import { ThreeDot } from "react-loading-indicators";

const RealtorAdBanner = () => {
  const dispatch = useDispatch();
  const userId = localStorage.getItem("user_id");
  const userType = localStorage.getItem("user_type");
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [count, setCount] = useState(0);
  const [id, setId] = useState("");
  const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);
  const [showSimpleModal, setShowSimpleModal] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const [bannerUrl, setBannerUrl] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedSub, setSelectedSub] = useState(null);
  const [price, setPrice] = useState(null);
  const [subType, setSubType] = useState("");
  const [missingCities, setMissingCities] = useState([]);
  const [open, setOpen] = React.useState(false);

  const { data } = useSelector((state) => state.fetchAllCities);
  const {
    data: subscribedCities,
    loading,
    error,
  } = useSelector((state) => state.vendorFetchSubscription);
  const { data: profileData } = useSelector((state) => state.fetchProfileData);
  const { data: productList } = useSelector((state) => state.fetchProductList);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    dispatch(fetchBannerImage(userId));
  }, [dispatch, userId]);

  useEffect(() => {
    const citiesWithoutBanner = subscribedCities?.data?.filter(
      (vendor) => !vendor.banner?.ads_banner_image
    );
    // ?.map(vendor => vendor.city);

    if (citiesWithoutBanner?.length > 0) {
      handleOpen();
      setMissingCities(citiesWithoutBanner);
    }
  }, [subscribedCities?.data]);

  useEffect(() => {
    dispatch(vendorFetchSubscriptionApi(userId));
  }, [dispatch, userId]);

  useEffect(() => {
    dispatch(
      fetchAllCities({ page: page, page_size: pageSize, search: search })
    );
  }, [dispatch, page, pageSize, search]);

  useEffect(() => {
    setCount(data?.data?.count);
  }, [data?.data?.count]);

  useEffect(() => {
    if (productList?.data?.length > 0) {
      const product = productList.data.find(
        (item) => item.metadata.Type.name === "ad_banner"
      );
      setPrice(product?.default_price?.unit_amount);
      setSubType(product?.name);
    }
  }, [productList, userType]);

  const handleCloseSimpleModal = () => setShowSimpleModal(false);
  const handleOpenSimpleModal = (image) => {
    setImageUrl(image?.ads_banner_image);
    setBannerUrl(image?.ads_banner_url);
    setShowSimpleModal(true);
  };

  const handleOpenModal = (sub) => {
    setSelectedSub(sub);
    setShowModal(true);
  };

  const handleCancelSubscription = () => {
    if (selectedSub) {
      const payload = {
        user_id: userId,
        ...(profileData?.data?.is_super_subscribed
          ? { record_id: selectedSub.id }
          : {
              subscription_id: selectedSub.stripe_subscription_id,
              city_id: selectedSub.city_id,
            }),
      };

      dispatch(vendorCancelSubscriptionApi(payload))
        .then((res) => {
          if (res?.payload?.status === 200) {
            toast.success(res?.payload?.message);
            setShowModal(false);
            dispatch(vendorFetchSubscriptionApi(userId));
          }
        })
        .catch((error) => {
          toast.error(error.message);
          setShowModal(false);
        });
    }
  };

  if (loading)
    return (
      <div>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "75vh",
            flexDirection: "column",
            textAlign: "center",
          }}
        >
          <ThreeDot color="#e55426" size="small" text="" textColor="" />
        </Box>
      </div>
    );

  return (
    <div>
      <div className="community-section">
        <div className="community-inner-wrap">
          <div className="add-new-community d-flex justify-content-between align-items-start flex-column">
            <div className="w-100 d-flex align-items-center justify-content-between subscription-area-blk">
              <div className="community-heading">
                Advertisement Banner Subscriptions
              </div>
            </div>
            <div className="expert-title">
              Secure the exclusive right to establish yourself as the
              community's foremost real estate expert.
            </div>
          </div>

          <div className="community-name-table">
            <div className="community-tabs-section d-none"></div>
            <div className="training-ai-blk">
              <div className="tab-content mt-3">
                <div className="contact-content  mt-4 training-ai-block">
                  <div className="contact-us-block-form text-start">
                    <div className="table-inner">
                      <table className="table table-borderless">
                        <thead className="exp-sub-heading">
                          <tr>
                            <th scope="col">City</th>
                            <th scope="col">State</th>
                            {/* <th scope="col">Zipcode</th> */}
                            <th scope="col">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {!error ? (
                            subscribedCities?.data?.map((city, index) => (
                              <tr key={city?.id}>
                                <td>{city?.city}</td>
                                <td>{city?.state}</td>
                                {/* <td>33101</td> */}
                                <td>
                                  <div className="d-flex gap-2">
                                    <UploadBannerModal id={city?.id} />
                                    <a
                                      style={{ cursor: "pointer" }}
                                      title="View Banner"
                                      onClick={() =>
                                        handleOpenSimpleModal(city?.banner)
                                      }
                                    >
                                      <div className="view-icon-eye">
                                        <svg
                                          width="15"
                                          height="14"
                                          viewBox="0 0 23 14"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M11.2772 7.20095L11.2775 7.20124C11.3939 7.3299 11.5511 7.37848 11.6814 7.39721C11.8148 7.41637 11.9605 7.41017 12.1008 7.39443C12.3541 7.36601 12.647 7.29888 12.913 7.23793C12.9403 7.23166 12.9674 7.22546 12.9941 7.21937C13.2974 7.15023 13.5476 7.09773 13.7196 7.09394C13.7326 7.09365 13.7442 7.09369 13.7544 7.09395C13.7039 8.25914 12.7191 9.20018 11.5 9.20018C10.2472 9.20018 9.24355 8.20822 9.24355 7C9.24355 5.80607 10.2236 4.82332 11.4557 4.80024C11.4558 4.80514 11.4559 4.81046 11.4558 4.81623C11.4552 4.96226 11.401 5.18477 11.3211 5.47591C11.3128 5.50623 11.3042 5.53716 11.2955 5.56858C11.2267 5.81731 11.1493 6.09697 11.1129 6.34728C11.0922 6.48979 11.082 6.63906 11.0991 6.77985C11.1162 6.92086 11.1636 7.07498 11.2772 7.20095ZM0.3 7C0.3 6.99221 0.303779 6.95415 0.330103 6.87721C0.354936 6.80463 0.394591 6.71243 0.451398 6.60209C0.564888 6.38165 0.7391 6.10377 0.975787 5.78837C1.44872 5.15817 2.16041 4.3924 3.10559 3.65187C4.99442 2.17201 7.80594 0.8 11.5 0.8C15.1935 0.8 18.005 2.172 19.894 3.65187C20.8392 4.39241 21.551 5.15819 22.0241 5.78839C22.2608 6.10379 22.4351 6.38167 22.5486 6.60211C22.6054 6.71245 22.6451 6.80466 22.6699 6.87724C22.6962 6.95417 22.7 6.99222 22.7 7C22.7 7.00045 22.7 6.99965 22.7 7.00016C22.7 7.00069 22.7 7.00003 22.7 7.00063L22.6999 7.00247L22.6992 7.00951C22.6985 7.01572 22.6971 7.02421 22.6948 7.03514C22.6902 7.05728 22.6823 7.0862 22.6699 7.12227C22.6451 7.19475 22.6054 7.28687 22.5486 7.39715C22.4351 7.61745 22.2608 7.89525 22.0241 8.21061C21.551 8.84073 20.8392 9.60659 19.894 10.3473C18.005 11.8274 15.1934 13.2 11.5 13.2C7.80598 13.2 4.99446 11.8274 3.10561 10.3473C2.16042 9.6066 1.44872 8.84074 0.975773 8.21063C0.739078 7.89528 0.564857 7.61748 0.451361 7.39717C0.39455 7.2869 0.354896 7.19478 0.330067 7.1223C0.31771 7.08622 0.309813 7.0573 0.305159 7.03515C0.30286 7.02422 0.301521 7.01574 0.300779 7.00952L0.300108 7.00248L0.300014 7.00063C0.299992 7.00003 0.300008 7.00069 0.300002 7.00016C0.29999 6.99965 0.299997 7.00045 0.3 7ZM6.08825 7C6.08825 9.9333 8.51741 12.2992 11.5 12.2992C14.4827 12.2992 16.9106 9.93321 16.9106 7C16.9106 4.06697 14.4829 1.69848 11.5 1.69848C8.51722 1.69848 6.08825 4.06688 6.08825 7Z"
                                            stroke="#000000"
                                            strokeWidth="0.6"
                                          />
                                        </svg>
                                      </div>
                                    </a>
                                    <a
                                      style={{ cursor: "pointer" }}
                                      title="Cancel Subscription"
                                      onClick={() => handleOpenModal(city)}
                                      disabled={
                                        city?.payment_status === "30days_trial"
                                      }
                                    >
                                      <div className="view-icon-eye">
                                        <svg
                                          width="14"
                                          height="14"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M10.5859 12L2.79297 4.20706L4.20718 2.79285L12.0001 10.5857L19.793 2.79285L21.2072 4.20706L13.4143 12L21.2072 19.7928L19.793 21.2071L12.0001 13.4142L4.20718 21.2071L2.79297 19.7928L10.5859 12Z"
                                            stroke="#000000"
                                            strokeWidth="1"
                                          ></path>
                                        </svg>
                                      </div>
                                    </a>
                                  </div>
                                </td>
                                {!city?.banner?.ads_banner_image ? (
                                  <td>
                                    <Tooltip
                                      title="Upload a banner to display your advertisement"
                                      arrow
                                    >
                                      <a style={{ cursor: "pointer" }}>
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="28"
                                          height="28"
                                          fill="none"
                                          viewBox="0 0 24 24"
                                          strokeWidth="1.5"
                                          stroke="#E9D502"
                                        >
                                          <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
                                          />
                                        </svg>
                                      </a>
                                    </Tooltip>
                                  </td>
                                ) : null}
                              </tr>
                            ))
                          ) : (
                            <tr>{<td>No active subscription</td>}</tr>
                          )}
                        </tbody>
                      </table>
                      <div>
                        <Modal
                          show={showModal}
                          onHide={() => setShowModal(false)}
                          size="sm"
                          centered
                        >
                          <Modal.Header className="d-flex justify-content-center">
                            <Modal.Title className="fw-bold">
                              Cancel Subscription
                            </Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <div className="text-center">
                              <p className="text-muted">
                                Are you sure you want to cancel your
                                subscription for <b>{selectedSub?.city}</b>?
                              </p>
                            </div>
                          </Modal.Body>
                          <Modal.Footer className="d-flex justify-content-between">
                            <button
                              className="bttn-upload"
                              onClick={() => setShowModal(false)}
                            >
                              No, Keep It
                            </button>
                            <button
                              className="bttn-close"
                              onClick={handleCancelSubscription}
                            >
                              Cancel
                            </button>
                          </Modal.Footer>
                        </Modal>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="all-commmunities-table">
          <div className="inner-wrap-all">
            <div className="title-search-block d-flex justify-content-between flex-column">
              <div className="d-flex justify-content-between">
                <div className="community-heading">Find a City</div>
                <div className="">
                  {subType && <Chip color="primary" label={subType} />}{" "}
                  {price && (
                    <Chip color="success" label={price ? `$${price}` : "N/A"} />
                  )}
                </div>
              </div>
              <div className="community-searchbar-main">
                <div className="inner-searchbar mt-3">
                  <div className="input-searchbar loader-block">
                    <input
                      type="search"
                      value={search}
                      onChange={(e) => {
                        const value = e.target.value;
                        setSearch(value);
                      }}
                      placeholder="Search by City Name"
                    />
                    <div className="owl_logo_searchbar">
                      <a href="#">
                        <img
                          src={community_icon}
                          alt="owl_logo"
                          width="20"
                          height="20"
                        ></img>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="community-name-table communityblk">
              <div className="table-inner">
                <table className="table table-borderless">
                  <thead className="exp-sub-heading">
                    <tr>
                      <th scope="col">City</th>
                      <th scope="col">State</th>
                      {/* <th scope="col">Zipcode</th> */}
                      <th scope="col">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.data?.data?.length > 0 ? (
                      data?.data?.data?.map((city, index) => (
                        <tr key={city?.id}>
                          <td>{city.city}</td>
                          <td>{city.state}</td>
                          {/* <td>{city.zip_code || "N/A"}</td> */}
                          <td>
                            <button
                              className="btn-submit-claim unsubscribe"
                              onClick={() => {
                                setShowSubscriptionModal(true);
                                setId(city?.id);
                              }}
                              disabled={!city?.lessthansix}
                            >
                              {city?.lessthansix ? "Subscribe" : "Sold Out"}
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="4">No cities available</td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <PaginationComponent
                  count={count}
                  pageSize={pageSize}
                  setPageSize={setPageSize}
                  page={page}
                  setPage={setPage}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {
        <AlertDialog
          open={open}
          handleClose={handleClose}
          missingCities={missingCities}
        />
      }
      <PurchaseSubscriptionModal
        show={showSubscriptionModal}
        id={id}
        onHide={() => setShowSubscriptionModal(false)}
        fetchSubscription={() => dispatch(vendorFetchSubscriptionApi(userId))}
      />
      <ViewImageModal
        imageUrl={imageUrl}
        bannerUrl={bannerUrl}
        showModal={showSimpleModal}
        handleClose={handleCloseSimpleModal}
      />
    </div>
  );
};

export default RealtorAdBanner;
